import photo from '../../img/fotos/Foto_Hero.jpg';

import { useIdioma } from '../../context/IdiomaContext';

import './Hero.css';

function Hero() {
  const { t } = useIdioma();

  return (
    <section
      id="inicio"
      className="hero"
    >
      <div className="hero-layout">
        <div className="hero-imagen">
          <img
            src={photo}
            alt={t('hero.imagenAlt')}
          />
        </div>

        <div className="hero-content">
          <h1>
            <span className="hero-frase">
              {t('hero.frase1.linea1')}
              <br />
              {t('hero.frase1.linea2')}
            </span>

            <span className="hero-frase">
              {t('hero.frase2.linea1')}
              <br />
              {t('hero.frase2.linea2')}
            </span>

            <span className="hero-frase">
              {t('hero.frase3.linea1')}
              <br />
              {t('hero.frase3.linea2')}
            </span>
          </h1>

          <p>
            {t('hero.descripcion')}
          </p>
        </div>

        <a
          href="#sobre-mi-inicio"
          className="hero-button"
        >
          <span className="hero-button-text">
            {t('hero.boton')}
          </span>

          <span
            className="hero-button-arrow"
            aria-hidden="true"
          >
            ↓
          </span>
        </a>
      </div>
    </section>
  );
}

export default Hero;